@if ((questions$ | async)?.length) {
  <nscf-ui-heading-questions [title]="data?.title" [questions]="questions$ | async"></nscf-ui-heading-questions>
}
